import { render } from "./StickyView.vue?vue&type=template&id=3f64cbe8"
import script from "./StickyView.vue?vue&type=script&lang=js"
export * from "./StickyView.vue?vue&type=script&lang=js"

import "./StickyView.vue?vue&type=style&index=0&id=3f64cbe8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__